import React, {useEffect, useState} from "react";
import {Image, useWindowDimensions, View} from 'react-native';
import {Button, Input, Spinner, Text, Modal} from '@ui-kitten/components';
import {MaterialIcons} from '@expo/vector-icons';
import {WelcomeSlider} from "./login/welcome-slider/welcome-slider";
import withEmailSign from "./shared/withEmailSign";
import {ModalVerifyCode} from "./login/modal-verify-code";
import {HomeScreen} from "./auth-zone/screens/home/home-screen";
import {ScrollView} from "react-native-gesture-handler";
import {ModalLayout} from "./shared/modal-layout";
import {Header} from "./auth-zone/header";
import {AsyncButtonWithSpinner} from "./shared/async-button-with-spinner";

function Login({ emailSign, emailSignVerifCode, needVerifCode }) {
  const [showSignInForm, setShowSignInForm] = useState(false)
  const [email, setEmail] = useState(false);
  const { width } = useWindowDimensions()

  return <>
      <Header />

      <ScrollView style={{marginTop: -(width * 62 / 1078), height: '100%' }}>
        <HomeScreen isSignIn={false} setCurrentPage={() => setShowSignInForm(true)} />
      </ScrollView>

      <WelcomeSlider />

      {showSignInForm && <ModalLayout title="Welcome !" close={() => setShowSignInForm(false)}>
          <View style={{backgroundColor: 'white', borderRadius: 5}}>
              <Text style={{textAlign: 'center', marginBottom: 30}}>to continue please enter your email</Text>

              <Input style={{borderRadius: 0, width: '100%'}} size="large" placeholder="Your email"
                     autoCompleteType="off" autoCorrect={false} keyboardType="email-address" autoCapitalize="none"
                     onChangeText={text => setEmail(text)}/>
              <AsyncButtonWithSpinner onPress={() => emailSign(email)} onWhite={true}>Go</AsyncButtonWithSpinner>

          </View>

      </ModalLayout>}

      <ModalVerifyCode visible={needVerifCode} email={email} emailSignVerifCode={emailSignVerifCode} />
    </>
}

export default withEmailSign(Login)